"use client";

import { useState, useCallback } from "react";

const LazyLoader = ({
  children,
  placeholderHeight = 800,
  rootMargin = "800px 0px",
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const resolvedHeight =
    typeof placeholderHeight === "number"
      ? `${placeholderHeight}px`
      : placeholderHeight;

  // Use callback ref to attach observer without the need for a wrapping div
  const setRef = useCallback((node) => {
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0, rootMargin }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [rootMargin]);

  // Render content only when it's visible, using Fragment to avoid extra wrappers
  return (
    <>
      {isVisible ? (
        children
      ) : (
        <div style={{ minHeight: resolvedHeight }} ref={setRef} />
      )}
    </>
  );
};

export default LazyLoader;
